export const GTM_EVENTS = {
  CREDENTIAL_UPLOAD: 'credential_upload',
  USER_REGISTER: 'user_register',
  EVALUATION_REQUEST: 'evaluation_request',
  INVOICE_OPERATION: 'invoice_operation',
};

export default GTM_EVENTS;
